import { type Dictionary } from '@ngrx/entity';

import { type ConnectorOAuthConfig } from '@blaze-shared/connectors-domain';

export const ConnectorOAuthConfigs: Dictionary<ConnectorOAuthConfig> = {
  DocuSign: {
    target: 'DocuSign',
    serviceName: 'DocuSign',
    urlName: 'docusign',
  },
  Square: {
    target: 'Square',
    serviceName: 'Square',
    urlName: 'square',
  },
  QuickBooks: {
    target: 'QuickBooks',
    serviceName: 'QuickBooks',
    urlName: 'quickbooks',
    allowedInstallFields: ['realmId'],
    actionAfterDefinition: 'showDatasets',
  },
  Salesforce: {
    target: 'Salesforce',
    serviceName: 'Salesforce',
    urlName: 'salesforce',
    actionAfterDefinition: 'showDatasets',
  },
};
